import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import {GridModule, PDFModule} from "@progress/kendo-angular-grid";
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import {RouterModule} from "@angular/router";
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DepartmentPipe } from './pipes/department.pipe';
import {ReactiveFormsModule} from "@angular/forms";
import {DatePickerModule, TimePickerModule} from "@progress/kendo-angular-dateinputs";
import { NotificationComponent } from './notification/notification.component';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { LabelModule } from '@progress/kendo-angular-label';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { TranslocoModule } from '@jsverse/transloco';
import { TranslocoRootModule } from '../transloco-root.module';
import { LayoutModule, TabStripModule } from '@progress/kendo-angular-layout';
import { EditorModule } from '@progress/kendo-angular-editor';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { ContactComboboxComponent } from './contact-combobox/contact-combobox.component';
import { SchedulerSharedComponent } from './scheduler-shared/scheduler-shared.component';
import { TimeEntryGridComponent } from './time-entry-grid/time-entry-grid.component';
import { TimeTrackingStartStopComponent } from './time-tracking-start-stop/time-tracking-start-stop.component';
import { AssignmentComboboxComponent } from './assignment-combobox/assignment-combobox.component';
import { IconsModule } from '@progress/kendo-angular-icons';
import { TimeSpanToStringPipe } from './pipes/timespan-to-string.pipe';
import { PermissionPipe } from './pipes/permission.pipe';
import { WeekReportingGridComponent } from './week-reporting-grid/week-reporting-grid.component';
import { DayReportingGridComponent } from './day-reporting-grid/day-reporting-grid.component';
import { EmployeePipe } from './pipes/employee.pipe';
import { StringToTimeObjectPipe } from './pipes/string-to-time-object.pipe';
import { AbsenceGroupGridComponent } from './absence-group-grid/absence-group-grid.component';
import { AbsenceSchedulerComponent } from './absence-scheduler/absence-scheduler.component';
import { LoadingIndicationDirective } from './directives/loading-indication.directive';
import { FiscalYearPipe } from './pipes/fiscal-year.pipe';
import { DateCustomPipe } from './pipes/date-custom.pipe';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { UtilsModule } from '@progress/kendo-angular-utils';
import { AssignmentListComponent } from "./assignment-list/assignment-list.component";
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { PermissionIfDirective, PermissionIfNotDirective } from './directives/permissionIf.directive';
import { TimeSupplementReportGridComponent } from './time-supplement-report-grid/time-supplement-report-grid.component';
import { ChangeHistoryComponent } from './change-history/change-history.component';
import { UserPipe } from './pipes/user.pipe';
import { WindowModule } from '@progress/kendo-angular-dialog';
import { InfoButtonComponent } from './info-button/info-button.component';
import { DeleteConfirmDialogComponent } from './delete-confirm-dialog/delete-confirm-dialog.component';
// TODO: Rename Module --> Conflict with Kendoo Module

@NgModule({
  declarations: [
    DepartmentPipe,
    NotificationComponent,
    ContactComboboxComponent,
    TimeEntryGridComponent,
    SchedulerSharedComponent,
    TimeTrackingStartStopComponent,
    AssignmentComboboxComponent,
    TimeSpanToStringPipe,
    PermissionPipe,
    WeekReportingGridComponent,
    DayReportingGridComponent,
    AbsenceGroupGridComponent,
    EmployeePipe,
    StringToTimeObjectPipe,
    AbsenceSchedulerComponent,
    LoadingIndicationDirective,
    FiscalYearPipe,
    DateCustomPipe,
    AssignmentListComponent,
    PermissionIfDirective,
    PermissionIfNotDirective,
    TimeSupplementReportGridComponent,
    ChangeHistoryComponent,
    UserPipe,
    InfoButtonComponent,
    DeleteConfirmDialogComponent
  ],
  imports: [
    CommonModule,
    GridModule,
    BrowserModule,
    BrowserAnimationsModule,
    SchedulerModule,
    DropDownsModule,
    RouterModule,
    ReactiveFormsModule,
    DatePickerModule,
    TimePickerModule,
    DialogsModule,
    LabelModule,
    ReactiveFormsModule,
    ListViewModule,
    TooltipsModule,
    UploadsModule,
    ButtonsModule,
    DateInputsModule,
    TranslocoRootModule,
    TranslocoModule,
    TabStripModule,
    EditorModule,
    IconsModule,
    InputsModule,
    UtilsModule,
    LayoutModule,
    PDFModule,
    ProgressBarModule,
    GaugesModule,
    ChartsModule,
    WindowModule
],
  exports: [
    GridModule,
    SchedulerModule,
    RouterModule,
    DropDownsModule,
    DepartmentPipe,
    ReactiveFormsModule,
    DatePickerModule,
    TimePickerModule,
    NotificationComponent,
    DialogsModule,
    LabelModule,
    ReactiveFormsModule,
    ListViewModule,
    TooltipsModule,
    ButtonsModule,
    DateInputsModule,
    TranslocoRootModule,
    TranslocoModule,
    TabStripModule,
    EditorModule,
    ContactComboboxComponent,
    TimeEntryGridComponent,
    SchedulerSharedComponent,
    AssignmentComboboxComponent,
    TimeTrackingStartStopComponent,
    IconsModule,
    TimeSpanToStringPipe,
    PermissionPipe,
    WeekReportingGridComponent,
    DayReportingGridComponent,
    AbsenceGroupGridComponent,
    EmployeePipe,
    StringToTimeObjectPipe,
    AbsenceSchedulerComponent,
    LoadingIndicationDirective,
    PermissionIfDirective,
    PermissionIfNotDirective,
    FiscalYearPipe,
    DateCustomPipe,
    InputsModule,
    UtilsModule,
    AssignmentListComponent,
    LayoutModule,
    PDFModule,
    ProgressBarModule,
    GaugesModule,
    ChartsModule,
    TimeSupplementReportGridComponent,
    UserPipe,
    InfoButtonComponent,
    DeleteConfirmDialogComponent
  ],
  providers: [AsyncPipe]
})
export class SharedModule { }
